import * as React from 'react';
import { SVGProps } from 'react';

const IconSectionOffsetSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14 2.868a.7.7 0 0 0-.848-.684L2.788 4.43A1 1 0 0 0 2 5.407v7.725a.7.7 0 0 0 .848.684l10.364-2.246a1 1 0 0 0 .788-.978V2.868Z"
      fill="var(--color-bg-ghost)"
    />
    <path
      d="M14 9.222c-.253-.058-.52-.132-.807-.211-1.41-.391-3.283-.91-6.19-.232-2.5.583-4.166 2.354-5 3.24v-1.66s3.5-3.305 7.498-4.237c4-.933 4.499 1.44 4.499 1.44v1.66Z"
      fill="var(--color-bg-normal)"
    />
    <path
      d="M2 12.142c.438-.293.916-.513 1.386-.73.135-.062.27-.124.403-.188a23.075 23.075 0 0 1 4.667-1.628c1.736-.405 4.046-.669 5.544-.152v1.067c-1.41-.531-3.971-.226-5.544.14-1.58.369-3.745 1.211-6.378 2.802A.696.696 0 0 1 2 13.132v-.99Z"
      fill="var(--color-bg-alert)"
    />
    <path
      d="M14 5.52v1.128c-.808-.502-1.67-.837-2.622-1.062C10.13 5.29 8.463 5.11 6.71 5.52c-.86.2-2.905.912-4.71 3.223V7.648c1.355-1.777 2.932-2.515 4.71-2.93 1.973-.46 3.8-.251 5.114.06.66.156 1.201.34 1.578.485a8.99 8.99 0 0 1 .554.236l.032.015.008.005.003.001H14Z"
      fill="var(--color-bg-warning)"
    />
    <path
      d="M8 12.7V3.3l5.212 1.13a1 1 0 0 1 .788.977v7.725a.7.7 0 0 1-.848.684L8 12.7Z"
      fill="#CCD9E0"
    />
    <path
      d="M8 5.317v-.813c.42.043.852.112 1.29.214 1.778.415 3.355 1.153 4.71 2.93v1.095C12.195 6.432 10.15 5.72 9.29 5.52A9.103 9.103 0 0 0 8 5.317Z"
      fill="var(--color-bg-warning)"
    />
    <path
      d="M8 8.585V6.584c3.334 1.26 5.996 3.776 5.996 3.776v1.66c-.833-.887-2.5-2.658-4.998-3.24-.347-.082-.68-.146-.998-.195Z"
      fill="var(--color-bg-normal)"
    />
    <path
      d="M8 10.767v-1.06a23.012 23.012 0 0 1 4.21 1.517c.134.064.269.126.404.188.47.217.948.437 1.386.73v.99a.697.697 0 0 1-.078.321C11.534 12.01 9.53 11.183 8 10.767Z"
      fill="var(--color-bg-alert)"
    />
  </svg>
);
export default IconSectionOffsetSizeS;
